import React from 'react';

export const NotFoundError: React.FC = () => {
  return (
    <div>
      404 Not Found
    </div>
  );
};